import RestaurantOfferStore from '@components/offer/stores/RestaurantOfferStore';
import OrderListViewStore from '@components/order/stores/OrderListViewStore';
import { Box, Button, Paper, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';

interface BottomActionProps {
    orderListViewStore: OrderListViewStore;
}

const BottomAction: React.FC<BottomActionProps> = observer(({ orderListViewStore }) => {
    const { onAddToOrderCartClick } = orderListViewStore;
    return (

        <Button
            onClick={onAddToOrderCartClick}
            fullWidth
            color='secondary'
            variant="contained">
            <Typography>Dodaj u košaricu</Typography>
        </Button>
    )
})

export default BottomAction;